import { useState, useEffect } from 'react';

const useIsServer = () => {
    const [isServer, setIsServer] = useState(typeof window === 'undefined');

    useEffect(() => {
        if (typeof window === 'undefined') {
            setIsServer(true);
        } else {
            setIsServer(false);
        }
    }, []);
    return isServer;
};

export default useIsServer;
